import React, { useContext, useEffect, useRef, useState } from "react";
import isEmpty from "lodash/isEmpty";
import Theme from "../../components/theme/Theme";
import Category from "../category/Category";
import CatalogNavList from "../category-nav/CategoryNavList/CategoryNavList";
import { useIntl, FormattedMessage } from "react-intl";
import Search from "../search-bar/SearchBar";
import { GlobalContext } from "../../globals/globalContext";
import ShoppingCart from "jsx:../../assets/svgs/shopping_cart.svg";
import { RiSearch2Line } from "react-icons/ri";
import "./styles.styl";

export default function CatalogItemList(props) {
  const reloadCatalog = () => {
    props.reRender();
  };
  const [openedId, setOpenedId] = useState();
  const [openedSubCategory, setOpenedSubCategory] = useState();
  const categoryRef = useRef();
  const categoryWrapperRef = useRef();
  const listRef = useRef(null);
  const { formatMessage } = useIntl();
  const { isMobile } = useContext(GlobalContext);
  const { colorPrimary } = useContext(GlobalContext) || props;
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const searchRef = useRef(null);

  const favouritesTranslated = formatMessage({
    id: "favourites",
  });

  const headerCategoryNames = props.categories
    ? props.categories
        .filter(category => category.is_header_category)
        .map(category => category.category)
    : [];

  const hasProducts = (categoryData) => categoryData && Object.keys(categoryData).some(
    (subcategory) => categoryData[subcategory]?.length > 0
  );

  const {
    delivery,
    footer_text_in_shop,
    allow_ordering_before_suggestions_at,
    isCatalogEmpty,
    isFilteredProduct,
    searchText,
    productsByCategory,
    onChange,
    onRemove,
    search,
  } = props;
  const sold = delivery?.sold ?? false;
  const editable = delivery?.editable ?? true;
  const items_deliver_listings = delivery
    ? delivery.orders.map((order) =>
        order.deliver_listing ? order.deliver_listing.id : order.id,
      )
    : [];

  useEffect(() => {
    const searchResultsTranslated = formatMessage({ id: "searchResults" });

    if (searchText && hasProducts(productsByCategory[searchResultsTranslated])) {
      setOpenedId(searchResultsTranslated);
      return;
    }

    if (
      (!openedId || openedId === searchResultsTranslated) &&
      productsByCategory &&
      Object.keys(productsByCategory).length > 0
    ) {
      const firstHeaderCategoryWithContent = headerCategoryNames.find(headerCategory =>
        hasProducts(productsByCategory[headerCategory])
      );

      if (firstHeaderCategoryWithContent) {
        setOpenedId(firstHeaderCategoryWithContent);
      } else {
        const firstNonEmptyCategory = Object.keys(productsByCategory).find(
          (category) => {
            if (
              [searchResultsTranslated, favouritesTranslated, ...headerCategoryNames].includes(category)
            )
              return false;
            return hasProducts(productsByCategory[category]);
          },
        );

        if (firstNonEmptyCategory) {
          setOpenedId(firstNonEmptyCategory);
        }
      }
    }
  }, [productsByCategory, formatMessage, searchText, headerCategoryNames]);

  const handleClick = (myOpenedId) => {
    setOpenedId(myOpenedId);
    setOpenedSubCategory("");
    if (myOpenedId !== formatMessage({ id: "searchResults" })) {
      search("");
    }
  };

  const handleSubCategoryClick = (category) => {
    if (categoryRef.current) {
      const categoryElement = document.querySelector(
        `div[data-category-title="${category}"]`,
      );

      if (categoryElement) {
        categoryElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  const handleCartClick = () => {
    const cartRow = document.querySelector(".cart__row");
    if (cartRow) {
      cartRow.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const isFavouriteEmpty = () => !hasProducts(productsByCategory[favouritesTranslated]);

  const products = productsByCategory[openedId];
  const name = openedId;

  const mainCategories = Object.keys(productsByCategory)
    .filter(
      (i) =>
        ![
          ...headerCategoryNames,
          favouritesTranslated,
          formatMessage({ id: "searchResults" }),
        ].includes(i),
    )
    .filter((category) => hasProducts(productsByCategory[category]));
  const isProductsByCategoryEmpty = isEmpty(productsByCategory);
  const subCategories =
    (openedId &&
      !isProductsByCategoryEmpty &&
      Object.keys(productsByCategory[openedId] ?? {})) ??
    [];
  const firstInitialSubCategory =
    (subCategories[0] && subCategories[0].trim()) ||
    (subCategories.length > 1 && subCategories[1]) ||
    null;

  const isCategoryFavourite = openedId === favouritesTranslated;
  const currentSelectedSubCategory = isEmpty(openedSubCategory)
    ? firstInitialSubCategory
    : openedSubCategory;

  const shouldHideHeaders = isProductsByCategoryEmpty || isCatalogEmpty;

  const dynamicHeaderCategories = headerCategoryNames.filter(category =>
    hasProducts(productsByCategory[category])
  );

  const headerCategories = [...dynamicHeaderCategories];

  if (!isFavouriteEmpty()) {
    headerCategories.push(favouritesTranslated);
  }

  const searchResultsTranslated = formatMessage({ id: "searchResults" });
  if (hasProducts(productsByCategory[searchResultsTranslated])) {
    headerCategories.unshift(searchResultsTranslated); // Add to beginning
  }

  const handleSearchIconClick = () => {
    const searchElement = document.querySelector(
      ".catalog-item-list__search-wrapper",
    );
    setIsSearchVisible(true);
    if (searchRef.current) {
      searchRef.current.focus();
    }
    if (searchElement) {
      setTimeout(() => {
        searchElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  };

  return (
    <>
      <div className="catalog-item-list__header-catalog catalog-item-list__selected">
        <div className="catalog-item-list" ref={listRef}>
          {isMobile && (
            <Search
              search={search}
              searchText={searchText}
              ref={searchRef}
              className="catalog-item-list__search-wrapper"
            />
          )}
          <div className="catalog-item-list__header catalog-item-list__title-search-wrapper">
            <CatalogNavList
              handleClick={handleClick}
              type="title"
              categories={headerCategories}
              currentSelected={openedId}
              productsByCategory={productsByCategory}
            />
            {!isMobile && (
              <Search
                search={search}
                searchText={searchText}
                className="catalog-item-list__search-wrapper"
              />
            )}

            {delivery && (
              <div className="catalog-item-list__theme-changer">
                <Theme
                  customer={delivery?.subscription?.customer}
                  reloadCatalog={reloadCatalog}
                />
              </div>
            )}
            {isMobile && (
              <div style={{ position: "relative" }} onClick={handleCartClick}>
                <ShoppingCart className="catalog-item-list__shopping-cart" />
                {delivery?.orders?.length > 0 && (
                  <span className="cart-counter">{delivery.orders.length}</span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {!shouldHideHeaders && (
        <>
          <CatalogNavList
            handleClick={handleClick}
            type="category"
            categories={mainCategories}
            currentSelected={openedId}
            productsByCategory={productsByCategory}
          />
          {!isCategoryFavourite &&
            openedId !== formatMessage({ id: "searchResults" }) && (
              <CatalogNavList
                type="subcategory"
                handleClick={handleSubCategoryClick}
                productsByCategory={productsByCategory[openedId]}
                parentProductsByCategory={productsByCategory}
                currentSelected={currentSelectedSubCategory}
                currentSelectedMainCategory={openedId}
              />
            )}
        </>
      )}
      <div
        id="category-wrapper"
        className="catalog-item-list__category-wrapper"
        ref={categoryWrapperRef}
      >
        {!shouldHideHeaders && (
          <Category
            items_deliver_listings={items_deliver_listings}
            onChange={onChange}
            onRemove={onRemove}
            name={name}
            products={products}
            setOpenedSubCategory={setOpenedSubCategory}
            categoryWrapperRef={categoryWrapperRef}
            key={name}
            sold={sold}
            editable={editable}
            allow_ordering_before_suggestions_at={
              allow_ordering_before_suggestions_at
            }
            handleClick={handleClick}
            openedId={openedId}
            delivery={delivery}
            reRender={props.reRender}
            categoryRef={categoryRef}
            isGrid={props.isGrid}
            ownerlessShop={props.ownerlessShop}
            listRef={listRef}
          />
        )}
        {isCatalogEmpty && (
          <p>
            <FormattedMessage id="allProductsInCart" />
          </p>
        )}
        {!isCatalogEmpty && (
          <div className="catalog-item-list__footnote">
            <p>{footer_text_in_shop}</p>
          </div>
        )}
      </div>
    </>
  );
}
